import { render, staticRenderFns } from "./Disassociate.vue?vue&type=template&id=5b4ed859"
import script from "./Disassociate.vue?vue&type=script&lang=js"
export * from "./Disassociate.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports